import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Box } from '@mui/material';
import Rating from '@mui/material/Rating';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { useTranslation } from 'react-i18next'; // Import useTranslation

const EventComment = ({ comment, commentKey }) => {
  const { t } = useTranslation(); 

  const labels = {
    1: t('eventCard.rating.useless'),
    2: t('eventCard.rating.poor'),
    3: t('eventCard.rating.ok'),
    4: t('eventCard.rating.good'),
    5: t('eventCard.rating.excellent'),
  };

  function getLabelText(value) {
    const label = labels[value];
    return `${value} ${t('eventCard.rating.banana', { count: value })}${label ? `, ${label}` : ''}`;
  }

  return (
    <Card key={commentKey} sx={{ mb: 1, background: '#fff', borderRadius: 2, boxShadow: 1 }}>
      <CardContent>
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5, display: 'flex', alignItems: 'center', gap: 1 }}>
          <PersonOutlineOutlinedIcon sx={{ fontSize: 18, mr: 0.5 }} />
          {comment.user.username || comment.user.email || 'Utilisateur'}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <AccessTimeOutlinedIcon sx={{ fontSize: 16, mr: 0.5 }} />
          {comment.updated_dt ? new Date(comment.updated_dt).toLocaleString() : ''}
        </Typography>
        {comment.rating && (
          <Box sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Rating
              name={`feedback-${commentKey}`}
              value={comment.rating || 0}
              precision={1}
              readOnly // Set the Rating component to read-only
              emptyIcon={<span style={{ fontSize: '1.0rem' }}>🍌</span>}
              icon={<span style={{ fontSize: '1.0rem' }}>🍌</span>}
              getLabelText={getLabelText}
              sx={{ textAlign: 'left' }} // Align the Rating component to the left
            />
          </Box>
        )}
        <Typography variant="body2" sx={{ mb: 1, textAlign: 'left', fontSize: '0.90rem' }}>
          {comment.comment}
        </Typography>

        
      </CardContent>
    </Card>
  );
};

EventComment.propTypes = {
  comment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    user: PropTypes.shape({
      username: PropTypes.string,
      email: PropTypes.string,
    }),
    updated_dt: PropTypes.string,
    rating: PropTypes.number,
    comment: PropTypes.string.isRequired,
  }).isRequired,
  commentKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default EventComment;